import { render, staticRenderFns } from "./CncParts.vue?vue&type=template&id=20035470&scoped=true"
import script from "./CncParts.vue?vue&type=script&lang=js"
export * from "./CncParts.vue?vue&type=script&lang=js"
import style0 from "./CncParts.vue?vue&type=style&index=0&id=20035470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20035470",
  null
  
)

export default component.exports